// import { ENABLE_TAX_FILE } from '../constants/global.constants';
import {
  CardType,
  LoginFormType,
  OtherWidgetType,
  globalCardsType,
} from '../types/chat.types';

// const customerSupport = {
//   label: 'book your appointment',
//   formItem: [
//     {
//       name: 'name',
//       placeHolder: 'Your Name',
//       type: 'text',
//       DataType: 'text',
//     },
//   ],
// };

const startFreeTrial: CardType = {
  type: 'adaptive-card',
  msg: '',
  actions: [
    { title: "We're excited to get start", actionType: 'newTax1099User' },
    { title: 'Back to Menu', actionType: 'menuCard' },
  ],
};

const startApiEnable: CardType = {
  type: 'adaptive-card',
  msg: '',
  actions: [
    { title: 'API Access', actionType: 'startSelectForm' },
    { title: 'Industry news, promotion', actionType: '' },
  ],
};

const custAndCaluCheckEstimatedPricing: CardType = {
  type: 'adaptive-card',
  msg: '',
  actions: [
    { title: 'Proceed to make payment ', actionType: '' },
    { title: 'Email me the estimate', actionType: '' },
    { title: 'Check whats include in plan', actionType: '' },
  ],
};
const thankYouCard: CardType = {
  type: 'adaptive-card',
  msg: 'Thank You ',
  actions: [{ title: 'Back to home page ', actionType: 'menuCard' }],
};

const removeCard: OtherWidgetType = {
  type: 'removeCard',
  actionType: 'removeCard',
};

const newTax1099User: LoginFormType = {
  deleteCard: false, //// indicate to delete last card
  title: 'SignUp',
  type: 'login-signup-form',
  actionType: 'redirectToApp',
};

const existingUserSignCard: LoginFormType = {
  deleteCard: false, //// indicate to delete last card
  title: 'Login',
  type: 'login-signup-form',
};

const existingTax1099User: CardType = {
  auth: true,
  deleteCard: false, //// indicate to delete last card
  type: 'adaptive-card',
  msg: 'Welcome $User ! We are thrilled to have you here again. How can we assist you today ?',
  actions: [
    { title: 'File New Form', actionType: 'fileNewForm' },
    { title: 'Check Submission Status', actionType: 'display-data-card' },
  ],
};

const contactSale: OtherWidgetType = {
  type: 'contactSale',
  data: [
    { title: 'True', actionType: 'redirectToApp' },
    { title: 'False', actionType: 'newTax1099User' },
  ],
};

const contactDemo: OtherWidgetType = {
  type: 'contactDemo',
  data: [
    { title: 'True', actionType: 'calendlyWidget' },
    { title: 'False', actionType: 'calendlyWidgetIntroCall' },
  ],
};

const contactDiscountedPricing: OtherWidgetType = {
  type: 'contactDiscountedPricing',
  data: [
    { title: 'True', actionType: 'calendlyWidget' },
    { title: 'False', actionType: 'calendlyWidgetIntroCall' },
  ],
};

const calendlyWidget: OtherWidgetType = {
  type: 'calendlyWidget',
  actionType: '',
};

const calendlyWidgetIntroCall: OtherWidgetType = {
  type: 'calendlyWidgetIntroCall',
  actionType: '',
}

const contactSaleCheckPricing: CardType = {
  type: 'adaptive-card',
  msg: 'Thank you for providing form count. We can best help you estimate your pricing through our calculator for your forms',
  actions: [{ title: 'Check Pricing', actionType: 'checkPricing' }],
};

const checkPricing: CardType = {
  type: 'adaptive-card',
  msg: 'Our pricing plans are designed to add value to your experience. We believe in transparency and providing you with the best solutions for your needs.',
  actions: [
    { title: 'Pricing Calculator', actionType: 'pricingCalculatorCard' },
    // { title: 'Compare Plans', actionType: 'compare-plans' },
    // { title: 'Contact Sales', actionType: 'contactSale' },
    // { title: 'Pricing Guide', actionType: 'pricing-guide' },
  ],
};

// const menuCard: CardType = ENABLE_TAX_FILE
//   ? {
//       auth: true,
//       type: 'adaptive-card',
//       msg: 'Welcome! Tax Compliance will never be the same. Experience the revolutionary 1099/94x/W2 AI-powered tool designed to assist businesses of all sizes, as well as CPAs and practitioners. Give it a try and get started by asking',
//       actions: [
//         {
//           title:
//             'Which form should I use when reporting payments to a contractor?',
//           actionType: 'send-chat', // send string to backend
//         },
//         {
//           title: 'Refer & Earn!',
//           actionType: 'refer-earn',
//         },
//         {
//           title: 'What types of forms do you support? ',
//           actionType: 'send-chat',
//         },
//         {
//           title: 'Questions about pricing and features?',
//           actionType: 'check-pricing',
//         },
//         {
//           title:
//             'File up to Fifty 1099 MISC and 1099 NEC swiftly through chat!',
//           actionType: 'filling1099Form',
//         },
//         {
//           title: 'Discounted rates for 1000+ forms',
//           actionType: 'contactSale',
//         },
//       ],
//     }
//   : {
//       auth: true,
//       type: 'adaptive-card',
//       msg: 'Welcome! Tax Compliance will never be the same. Experience the revolutionary 1099/94x/W2 AI-powered tool designed to assist businesses of all sizes, as well as CPAs and practitioners. Give it a try and get started by asking',
//       actions: [
//         {
//           title:
//             'Which form should I use when reporting payments to a contractor?',
//           actionType: 'send-chat', // send string to backend
//         },
//         {
//           title: 'Refer & Earn!',
//           actionType: 'refer-earn',
//         },
//         {
//           title: 'What types of forms do you support? ',
//           actionType: 'send-chat',
//         },
//         {
//           title: 'Questions about pricing and features?',
//           actionType: 'check-pricing',
//         },
//         {
//           title: 'Discounted rates for 1000+ forms',
//           actionType: 'contactSale',
//         },
//       ],
//     };

const menuCard: OtherWidgetType =
{
  type: 'copilot_intro',
  actionType: ''
}

const feedback_card: OtherWidgetType = {
  type: 'feedback_card',
  actionType: '',
};

const transfer_agent_card: OtherWidgetType = {
  type: 'transfer_agent_card',
  actionType: '',
};

const pricingCalculatorCard: OtherWidgetType = {
  type: 'pricingCalculatorCard',
  actionType: '',
};

const showReferenceNumberCard: OtherWidgetType = {
  type: 'showReferenceNumberCard',
  actionType: '',
};

const copilotIntro: any = {
  type: 'copilot_intro',
  actionType: "",
}
const redirectToApp: any = {
  type: 'redirectToApp',
  actionType: ""
}
const redirectToDashboard:any = {
  type: 'redirectToDashboard',
  actionType: ""
}
const confirmationMsg: OtherWidgetType = {
  type: 'confirmationMsg',
  actionType: "",
};

const calculateTaxAmount: OtherWidgetType = {
  type: 'calculateTaxAmount',
  actionType: ""
}

export const globalCards: globalCardsType = {
  feedback_card,
  transfer_agent_card,
  startFreeTrial,
  startApiEnable,
  custAndCaluCheckEstimatedPricing,
  thankYouCard,
  newTax1099User,
  existingTax1099User,
  menuCard,
  removeCard,
  existingUserSignCard,
  pricingCalculatorCard,
  contactSale,
  contactDemo,
  contactDiscountedPricing,
  calendlyWidget,
  calendlyWidgetIntroCall,
  checkPricing,
  contactSaleCheckPricing,
  showReferenceNumberCard,
  copilotIntro,
  redirectToApp,
  redirectToDashboard,
  confirmationMsg,
  calculateTaxAmount
};
